import {
    CONFIRMED_GET_HOW_TO_TAKES,
    CONFIRMED_CREATE_HOW_TO_TAKE,
    CONFIRMED_DELETE_HOW_TO_TAKE,
    CONFIRMED_EDIT_HOW_TO_TAKE,
  } from "../types/HowToTakeTypes";
  
  import {
    getHowToTakes,
    createHowToTake,
    updateHowToTake,
    deleteHowToTake,
    formatHowToTakes,
  } from "../../services/HowToTakeService";
  
  import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get How To Take list
  export function getHowToTakeAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
  ) {
    return async (dispatch) => {
      try {
        const response = await getHowToTakes(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        );
  
        if (response?.status === 200 && response.data?.status === "success") {
          const list = formatHowToTakes(response.data.data);
          const num_rows = response.data.num_rows || 0;
  
          dispatch({
            type: CONFIRMED_GET_HOW_TO_TAKES,
            payload: { list, num_rows },
          });
        } else {
          handleError("Failed to get How To Take");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to get How To Take");
      }
    };
  }
  
  // Delete
  export function deleteHowToTakeAction(howToTakeId) {
    return async (dispatch) => {
      try {
        await deleteHowToTake(howToTakeId);
        dispatch({
          type: CONFIRMED_DELETE_HOW_TO_TAKE,
          payload: { how_to_take_id: howToTakeId },
        });
        handleSuccess("How To Take deleted successfully!");
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete How To Take");
      }
    };
  }
  
  // Create
  export function createHowToTakeAction(howToTakeData, navigate) {
    return async (dispatch) => {
      try {
        const response = await createHowToTake(howToTakeData);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatHowToTakes([response.data.data])[0];
          dispatch({
            type: CONFIRMED_CREATE_HOW_TO_TAKE,
            payload: formatted,
          });
          if (navigate) navigate("/app-how-to-take");
          handleSuccess("How To Take created successfully!");
        } else {
          showErrorAlert("Failed to create How To Take");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to create How To Take");
      }
    };
  }
  
  // Update
  export function updateHowToTakeAction(howToTakeData, howToTakeId, navigate) {
    return async (dispatch) => {
      try {
        const payload = {
          ...howToTakeData,
          how_to_take_id: howToTakeId,
        };
  
        const response = await updateHowToTake(payload);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatHowToTakes([response.data.data])[0];
          dispatch({
            type: CONFIRMED_EDIT_HOW_TO_TAKE,
            payload: formatted,
          });
          if (navigate) navigate("/app-how-to-take");
          handleSuccess("How To Take updated successfully!");
        } else {
          showErrorAlert("Failed to update How To Take");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to update How To Take");
      }
    };
  }
  